import React from 'react';

export const PlusBlue = ({ width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00004 2.66211C8.36823 2.66211 8.66671 2.96059 8.66671 3.32878V12.6621C8.66671 13.0303 8.36823 13.3288 8.00004 13.3288C7.63185 13.3288 7.33337 13.0303 7.33337 12.6621V3.32878C7.33337 2.96059 7.63185 2.66211 8.00004 2.66211Z"
      fill="#1D4ED8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66663 7.99967C2.66663 7.63148 2.9651 7.33301 3.33329 7.33301H12.6666C13.0348 7.33301 13.3333 7.63148 13.3333 7.99967C13.3333 8.36786 13.0348 8.66634 12.6666 8.66634H3.33329C2.9651 8.66634 2.66663 8.36786 2.66663 7.99967Z"
      fill="#1D4ED8"
    />
  </svg>
);
